export function trackAgendarCitaClick(buttonLocation) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "agendar_cita_click", {
    button_location: buttonLocation,
    transport_type: "beacon",
  });
}
